// --- Our Modules --------------------------------------------------------------------------------
import useAuth from "@/hooks/useAuth";

// --- Logic --------------------------------------------------------------------------------------

/**
 * Mirrors the backend's `admins` branch in `auth.middleware.ts` — same short-circuits, same order.
 * Hiding a control the API would refuse anyway is the only job here; the API stays the authority.
 */
export default function usePermission() {
    const admin = useAuth((state) => state.admin);

    const canView = (model: string): boolean => {
        if (!admin) return false;
        if (admin.isSuper) return true;
        return admin.permissions.some((p) => p.model === model);
    };

    const canEdit = (model: string): boolean => {
        if (!admin) return false;
        if (admin.isSuper) return true;
        return admin.permissions.some((p) => p.model === model && p.actions.includes("edit"));
    };

    return { canView, canEdit };
}
